import style from './style';
const boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
export default boxShadow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/system/esm/shadows.js
// module id = 1108
// module chunks = 0